import { render, staticRenderFns } from "./DailyAscents.vue?vue&type=template&id=1cc1bae6&scoped=true"
import script from "./DailyAscents.vue?vue&type=script&lang=js"
export * from "./DailyAscents.vue?vue&type=script&lang=js"
import style0 from "./DailyAscents.vue?vue&type=style&index=0&id=1cc1bae6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc1bae6",
  null
  
)

export default component.exports